import { c as _c } from "react/compiler-runtime";
import { ACTION_MENU_ITEM_CLASS_NAME, ActionMenuItem, ActionMenuItemProps } from '@systemeio/ui';
import React, { type JSX } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { twMerge } from 'tailwind-merge';
type ActionMenuLinkItemProps = Omit<ActionMenuItemProps, 'label' | 'onClick' | 'buttonClassName' | 'labelClassName'> & {
  isNext?: boolean;
  label: string | JSX.Element;
  href: string;
  openInNew?: boolean;
  dataTestAttributes?: Record<string, string>;
};
export const ActionMenuLinkItem = t0 => {
  const $ = _c(15);
  let dataTestAttributes;
  let href;
  let label;
  let openInNew;
  let props;
  if ($[0] !== t0) {
    const {
      label: t1,
      href: t2,
      openInNew: t3,
      dataTestAttributes: t4,
      isNext,
      ...t5
    } = t0;
    label = t1;
    href = t2;
    openInNew = t3;
    dataTestAttributes = t4;
    props = t5;
    $[0] = t0;
    $[1] = dataTestAttributes;
    $[2] = href;
    $[3] = label;
    $[4] = openInNew;
    $[5] = props;
  } else {
    dataTestAttributes = $[1];
    href = $[2];
    label = $[3];
    openInNew = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== dataTestAttributes || $[7] !== href || $[8] !== label || $[9] !== openInNew || $[10] !== props.disabled) {
    t1 = t2 => {
      const {
        focus
      } = t2;
      return <LinkWithoutPrefetch type="button" aria-pressed={focus} href={href} className={twMerge(ACTION_MENU_ITEM_CLASS_NAME, props.disabled && "hover:text-text-secondary text-text-secondary cursor-not-allowed")} {...dataTestAttributes} {...openInNew ? {
        target: "_blank",
        rel: "noreferrer"
      } : {}}>{label}</LinkWithoutPrefetch>;
    };
    $[6] = dataTestAttributes;
    $[7] = href;
    $[8] = label;
    $[9] = openInNew;
    $[10] = props.disabled;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== props || $[13] !== t1) {
    t2 = <ActionMenuItem {...props}>{t1}</ActionMenuItem>;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};